import { reloadPage } from "./reloadPage";

/**
 * A whole-page message for what the app could not get past, with a way out: reload, or the landing page. It uses
 * Tailwind, which is always there; Mantine may be the very thing that failed to load.
 */
export function ErrorScreen({ title, message }: { title: string; message: string }) {
  return (
    <div role="alert" className="flex min-h-screen items-center justify-center bg-slate-900 p-4 text-slate-200">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-xl font-bold text-white">{title}</h1>
        <p className="mb-6 text-sm text-slate-400">{message}</p>
        <button
          type="button"
          onClick={reloadPage}
          className="rounded-md bg-[#5865F2] px-4 py-2 font-semibold text-white hover:bg-[#4752C4]"
        >
          Odśwież stronę
        </button>
        {/* A plain link: the error may have happened outside the router. */}
        <a href="/" className="mt-4 block text-sm text-slate-400 hover:text-slate-200">
          Wróć na stronę główną
        </a>
      </div>
    </div>
  );
}
